// Mirrors AssetTag's `normalizes` on the API: a faceted tag reads "facet:value".
const FACET_SEPARATOR = ":";

export const normalizeTagName = (name: string) =>
  name
    .trim()
    .toLowerCase()
    .replace(/ +/g, " ")
    .replace(/\s*:\s*/g, FACET_SEPARATOR)
    .replace(/^:/, "");

export const splitFacet = (name: string) => {
  const index = name.indexOf(FACET_SEPARATOR);
  return index === -1 ? { facet: null, value: name } : { facet: name.slice(0, index), value: name.slice(index + 1) };
};

// Typing a bare value keeps the tag in its facet; typing "facet:value" (or ":value" to drop the facet) is explicit.
export const renamedTagName = (currentName: string, typed: string) => {
  const { facet } = splitFacet(currentName);
  return typed.includes(FACET_SEPARATOR) || !facet ? normalizeTagName(typed) : normalizeTagName(`${facet}:${typed}`);
};
